import styled from 'styled-components';
import Theme from '../../theme';
import { remCalc } from '@lux/helpers';

export default {
  CrossLinkHorizontal: styled.div`
    display: flex;
    flex-flow: row nowrap;
    padding: ${remCalc(5)} 0;
    margin-bottom: ${remCalc(10)};
    ${Theme.media.lg`
      margin-bottom: ${remCalc(40)};
    `};
  `,
  Image: styled.img`
    height: ${remCalc(100)};
    order: 1;
  `,
  Content: styled.div`
    padding: 0 ${remCalc(8)} 0 ${remCalc(20)};
    text-align: left;
    order: 2;
  `,
  Title: styled.div`
    ${Theme.fonts.styles.Header6};
    letter-spacing: normal;
    margin-top: 0;
    margin-bottom: ${remCalc(5)};
  `,
  Description: styled.div`
    font-size: ${Theme.fonts.sizes.regular};
    line-height: normal;
  `
};
